import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { InputComponent } from "@components/input/input.component";
import { map, mergeMap, toArray } from "rxjs/operators";
import { BusyService } from "~app/common/components/busy/busy.service";
import { ToastService } from "~app/common/components/toast/toast.service";
import { IValidationContext } from "~app/common/validation/IValidationContext";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ForkalkylsmallarService } from "~app/features/virkeskop/services/forkalkylsmallar.service";
import { ForkalkylsmallDTO } from "../../models/ForkalkylsmallDTO";
import { ForkalkylsmallHandelssortimentDTO } from "../../models/ForkalkylsmallHandelssortimentDTO";
import { SkapaMallFranHandelssortimentValidation } from "./skapa-mall-fran-handelssortiment.validation";

@Component({
    selector: "rask-skapa-mall-fran-handelssortiment",
    templateUrl: "./skapa-mall-fran-handelssortiment.component.html",
    styleUrls: ["./skapa-mall-fran-handelssortiment.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ButtonComponent,
        InputComponent,
        FormsModule
    ]
})
export class SkapaMallFranHandelssortimentComponent implements OnInit {
    @Input() handelssortimentRows: ForkalkylsmallHandelssortimentDTO[];
    newMall: ForkalkylsmallDTO;
    @Output() refreshMinaForkalkylsmallar = new EventEmitter();
    showPanel = false;
    validationContext: IValidationContext;

    private readonly busyService = inject(BusyService);
    private readonly forkalkylsmallarService = inject(ForkalkylsmallarService);
    private readonly toastService = inject(ToastService);

    abort(event) {
        event.preventDefault();
        this.reset();
    }

    initValidation() {
        if (this.validationContext === undefined) {
            this.forkalkylsmallarService.getAllMallar().pipe(
                mergeMap(x => x),
                map(x => x.namn),
                toArray())
                .subscribe(nameList => {
                    this.validationContext = SkapaMallFranHandelssortimentValidation.init(this.newMall, nameList);
                });
        }
    }

    ngOnInit() {
        this.reset();
    }

    reset() {
        this.validationContext = undefined;
        this.newMall = new ForkalkylsmallDTO();
        this.showPanel = false;
    }

    saveAsMall(event) {
        event.preventDefault();
        this.validationContext.validate();

        if (!this.validationContext.hasErrors(ValidationScopes.spara)) {
            this.newMall.handelssortiment = this.handelssortimentRows;

            this.busyService.addWork(this.forkalkylsmallarService.updateMall(this.newMall)).subscribe(result => {
                this.toastService.add(`Mallen '${this.newMall.namn}' sparades`);
                this.reset();
                this.refreshMinaForkalkylsmallar.emit();
            });
        }
    }

    togglePopup(event) {
        // Förhindrar att exempelvis submit görs om denna komponent laddas in i en form
        event.preventDefault();
        this.showPanel = !this.showPanel;
        if (this.showPanel) {
            this.initValidation();
        }
    }
}
